<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Cleaver</h4>
            </div>
            <div class="card-body">
                
                <form [formGroup]="cleaverForm" (ngSubmit)="register()">
                    <div class="form-body">
                        <hr>

                            <div class="row" formGroupName="opcA">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción A</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div >
                                        <label class="control-label">M</label>
                                        <select formControlName="m" class="form-control custom-select">
                                            <option selected value="vacio">vacío</option>
                                            <option value="d">d</option>
                                            <option value="i">i</option>
                                            <option value="s">s</option>
                                            <option value="c">c</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div >
                                        <label class="control-label">L</label>
                                        <select formControlName="l" class="form-control custom-select">
                                            <option selected value="vacio">vacío</option>
                                            <option value="d">d</option>
                                            <option value="i">i</option>
                                            <option value="s">s</option>
                                            <option value="c">c</option>
                                        </select>
                                    </div>
                                </div>
                                
                            </div>

                            <div class="row" formGroupName="opcB">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción B</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div >
                                        <label class="control-label">M</label>
                                        <select formControlName="m" class="form-control custom-select">
                                            <option selected value="vacio">vacío</option>
                                            <option value="d">d</option>
                                            <option value="i">i</option>
                                            <option value="s">s</option>
                                            <option value="c">c</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div >
                                        <label class="control-label">L</label>
                                        <select formControlName="l" class="form-control custom-select">
                                            <option selected value="vacio">vacío</option>
                                            <option value="d">d</option>
                                            <option value="i">i</option>
                                            <option value="s">s</option>
                                            <option value="c">c</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row" formGroupName="opcC">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción C</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div >
                                        <label class="control-label">M</label>
                                        <select formControlName="m" class="form-control custom-select">
                                            <option selected value="vacio">vacío</option>
                                            <option value="d">d</option>
                                            <option value="i">i</option>
                                            <option value="s">s</option>
                                            <option value="c">c</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div >
                                        <label class="control-label">L</label>
                                        <select formControlName="l" class="form-control custom-select">
                                            <option selected value="vacio">vacío</option>
                                            <option value="d">d</option>
                                            <option value="i">i</option>
                                            <option value="s">s</option>
                                            <option value="c">c</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row" formGroupName="opcD">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción D</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción D">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div >
                                        <label class="control-label">M</label>
                                        <select formControlName="m" class="form-control custom-select">
                                            <option selected value="vacio">vacío</option>
                                            <option value="d">d</option>
                                            <option value="i">i</option>
                                            <option value="s">s</option>
                                            <option value="c">c</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div >
                                        <label class="control-label">L</label>
                                        <select formControlName="l" class="form-control custom-select">
                                            <option selected value="vacio">vacío</option>
                                            <option value="d">d</option>
                                            <option value="i">i</option>
                                            <option value="s">s</option>
                                            <option value="c">c</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        
                    </div>
                    <div class="form-actions">
                        <button type="submit" class="btn btn-success m-r-10"> <i class="fa fa-check"></i> Guardar</button>
                        <button type="button" class="btn btn-inverse" (click)="reset()">Reiniciar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>